export const simplePluralizeWord = (word: string, number: number): string =>
  `${word}${number === 1 ? '' : 's'}`;

export const clientPluralized = (number: number): string =>
  simplePluralizeWord('client', number);
